// extracted by mini-css-extract-plugin
export default {"add":"control_add__67zSA","tooltip":"control_tooltip__ru7W5"};